import { ref } from 'vue'

/**
 * RM-359 (Kapil 10/29): whether members see the Likelihood of Acceptance, as
 * the server last said (GET /reservation/:id/likelihood answers `shown`). Off
 * until an RM admin turns it on (Admin → Pending RM Review). Unknown (null)
 * until the first answer: no placeholder shows for a card that may not come.
 */
export const likelihoodShown = ref(null)

/** Keep what an answer from the likelihood read says. */
export function noteLikelihoodAnswer(data) {
  if (typeof data?.shown === 'boolean') likelihoodShown.value = data.shown
}

/** The card's placeholder only while a likelihood is known to be coming. */
export function placeholderWhile(loading) {
  return !!loading && likelihoodShown.value === true
}
